var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMempoolicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 2a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 1 0v-2a.5.5 0 0 0-.5-.5Zm2.333 0a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 1 0v-2a.5.5 0 0 0-.5-.5Zm1.834.5a.5.5 0 0 1 1 0v2a.5.5 0 1 1-1 0v-2ZM15.5 2a.5.5 0 0 0-.5.5v2a.5.5 0 1 0 1 0v-2a.5.5 0 0 0-.5-.5ZM8 19.5a.5.5 0 0 1 1 0v2a.5.5 0 0 1-1 0v-2Zm2.833-.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 1 0v-2a.5.5 0 0 0-.5-.5Zm1.834.5a.5.5 0 0 1 1 0v2a.5.5 0 1 1-1 0v-2ZM15.5 19a.5.5 0 0 0-.5.5v2a.5.5 0 1 0 1 0v-2a.5.5 0 0 0-.5-.5ZM2 8.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5ZM19.5 8a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1h-2ZM2 10.833a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5Zm17.5-.5a.5.5 0 0 0 0 1h2a.5.5 0 1 0 0-1h-2ZM2 13.167a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5Zm17.5-.5a.5.5 0 0 0 0 1h2a.5.5 0 1 0 0-1h-2ZM2 15.5a.5.5 0 0 1 .5-.5h2a.5.5 0 1 1 0 1h-2a.5.5 0 0 1-.5-.5Zm17.5-.5a.5.5 0 1 0 0 1h2a.5.5 0 0 0 0-1h-2Z",
    fill: "#139900"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M6 7a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7Z",
    fill: "#139900"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 7h10v10L7 7Z",
    fill: "#fff",
    fillOpacity: 0.12
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMempoolicon);
export default __webpack_public_path__ + "static/media/mempool.icon.c1351b7730501691e5436a9e6647f0f3.svg";
export { ForwardRef as ReactComponent };